import React from 'react';
import TextField from 'material-ui/TextField';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ChipInput from 'material-ui-chip-input';
import ContentSave from 'material-ui/svg-icons/content/save';
import ContentClear from 'material-ui/svg-icons/content/clear';
import AutoComplete from 'material-ui/AutoComplete';
import {
    GridList,
    GridTile,
} from 'material-ui/GridList';

import {
    subeventoService,
    areaService,
    Utils,
    pessoaService,
} from '../../services';
import PrincipalMaster from '../master/Principal';

class Area extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editing: false,
            subeventoSelecionado: this.props.match.params.subevento,
            nomeSubeventoSelecionado: '',
            dsSubeventos: [],
            nome: '',
            descricao: '',
            maxAutores: 0,
            minAutores: 0,
            maxAvaliadores: 0,
            minAvaliadores: 0,
            maxOrientadores: 0,
            minOrientadores: 0,
            isPosting: false,
            dsAvaliadoresArea: [],
            avaliadoresArea: [],
        };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        const form = await areaService.areaForm();
        this.csrfToken = form.token;
        this.formId = form.formId;
        const codigoArea = this.props.match.params.codigo;
        if (codigoArea) {
            try {
                const area = await areaService.getArea(codigoArea);
                this.setState({
                    editing: true,
                    nome: area.NOME,
                    descricao: area.DESCRICAO || '',
                    subeventoSelecionado: this.props.match.params.subevento,
                    nomeSubeventoSelecionado: area.NOMESUBEVENTO,
                    minAutores: area.MINAUTORES || 0,
                    maxAutores: area.MAXAUTORES || 0,
                    minAvaliadores: area.MINAVALIADORES || 0,
                    maxAvaliadores: area.MAXAVALIADORES || 0,
                    minOrientadores: area.MINORIENTADORES || 0,
                    maxOrientadores: area.MAXORIENTADORES || 0,
                    avaliadoresArea: area.avaliadoresArea || [],
                });
            } catch (error) {
                Utils.showToast(error.message);
            }
        } else {
            const subevento = await subeventoService.getSubevento(this.props.match.params.subevento);
            this.setState({ nomeSubeventoSelecionado: subevento.NOME });
        }
        Utils.showLoading(false);
    }

    async onGetSubeventos(value) {
        const subeventos = await subeventoService.getSubeventoPeloNome(value);
        this.setState({ dsSubeventos: subeventos, nomeSubeventoSelecionado: value });
    }

    async onSave(event) {
        event.preventDefault();
        const {
            editing,
            subeventoSelecionado,
            nome,
            descricao,
            maxAutores,
            minAutores,
            maxAvaliadores,
            minAvaliadores,
            maxOrientadores,
            minOrientadores,
            avaliadoresArea,
            isPosting,
        } = this.state;

        if (isPosting) {
            return;
        }

        this.setState({ isPosting: true });
        try {
            let response;
            if (editing) {
                response = await areaService.update({
                    codigo: +this.props.match.params.codigo,
                    subevento: subeventoSelecionado,
                    nome,
                    descricao,
                    maxAutores,
                    minAutores,
                    maxAvaliadores,
                    minAvaliadores,
                    maxOrientadores,
                    minOrientadores,
                    avaliadoresArea,
                    _csrf: this.csrfToken,
                    formId: this.formId,
                });
            } else {
                response = await areaService.save({
                    nome,
                    subevento: subeventoSelecionado,
                    descricao,
                    maxAutores,
                    minAutores,
                    maxAvaliadores,
                    minAvaliadores,
                    maxOrientadores,
                    minOrientadores,
                    avaliadoresArea,
                    _csrf: this.csrfToken,
                    formId: this.formId,
                });
            }
            Utils.showToast(response.message);
            this.props.history.goBack();
        } catch (e) {
            this.setState({ isPosting: false });
            Utils.showToast(e.message);
        }
    }

    async buscarAvaliadores(value) {
        let pessoas = await pessoaService.getPessoasByValue(value);
        pessoas = pessoas.map(x => ({ ...x, TEXT: `${x.NOME} (${x.CODIGOEDPESSOAS} - ${x.EMAIL})` }))
        this.setState({ dsAvaliadoresArea: pessoas });
    }

    render() {
        const {
            nome,
            descricao,
            maxAutores,
            dsSubeventos,
            minAutores,
            maxAvaliadores,
            minAvaliadores,
            maxOrientadores,
            minOrientadores,
            nomeSubeventoSelecionado,
            subeventoSelecionado,
            isPosting,
            avaliadoresArea,
            dsAvaliadoresArea,
        } = this.state;

        return (
            <PrincipalMaster title="Área" {...this.props}>
                <div>
                    <form onSubmit={e => this.onSave(e)}>
                        <div className="padding-content">
                            <AutoComplete
                                dataSource={dsSubeventos}
                                dataSourceConfig={{ text: 'NOME', value: 'CODIGO' }}
                                onUpdateInput={value => this.onGetSubeventos(value)}
                                onNewRequest={subevento => this.setState({ subeventoSelecionado: subevento.CODIGO })}
                                value={subeventoSelecionado}
                                filter={AutoComplete.noFilter}
                                floatingLabelText="Subevento"
                                openOnFocus
                                fullWidth
                                searchText={nomeSubeventoSelecionado}
                            />
                            <br />
                            <TextField
                                floatingLabelText="Nome"
                                value={nome}
                                onChange={e => this.setState({ nome: e.target.value })}
                                errorText={nome ? '' : 'Campo obrigatório'}
                                fullWidth
                                required
                            />
                            <br />
                            <TextField
                                floatingLabelText="Descrição"
                                value={descricao}
                                onChange={e => this.setState({ descricao: e.target.value })}
                                errorText={descricao ? '' : 'Campo obrigatório'}
                                fullWidth
                                required
                                multiLine
                                rows={3}
                            />
                            <GridList cols={2} cellHeight="auto">
                                <GridTile cols={1}>
                                    <TextField
                                        type="number"
                                        required
                                        value={minAutores}
                                        errorText={minAutores ? '' : 'Campo obrigatório'}
                                        floatingLabelText="Min. Autores"
                                        onChange={e => this.setState({ minAutores: e.target.value })}
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <TextField
                                        type="number"
                                        required
                                        value={maxAutores}
                                        errorText={maxAutores ? '' : 'Campo obrigatório'}
                                        floatingLabelText="Máx. autores"
                                        onChange={e => this.setState({ maxAutores: e.target.value })}
                                    />
                                </GridTile>
                            </GridList>
                            <GridList cols={2} cellHeight="auto">
                                <GridTile cols={1}>
                                    <TextField
                                        type="number"
                                        required
                                        value={minOrientadores}
                                        errorText={minOrientadores ? '' : 'Campo obrigatório'}
                                        floatingLabelText="Mín. orientadores"
                                        onChange={e => this.setState({ minOrientadores: e.target.value })}
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <TextField
                                        type="number"
                                        required
                                        value={maxOrientadores}
                                        errorText={maxOrientadores ? '' : 'Campo obrigatório'}
                                        floatingLabelText="Máx. orientadores"
                                        onChange={e => this.setState({ maxOrientadores: e.target.value })}
                                    />
                                </GridTile>
                            </GridList>
                            <GridList cols={2} cellHeight="auto">
                                <GridTile cols={1}>
                                    <TextField
                                        type="number"
                                        required
                                        value={minAvaliadores}
                                        errorText={minAvaliadores ? '' : 'Campo obrigatório'}
                                        floatingLabelText="Mín. avaliadores"
                                        onChange={e => this.setState({ minAvaliadores: e.target.value })}
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <TextField
                                        type="number"
                                        required
                                        value={maxAvaliadores}
                                        errorText={maxAvaliadores ? '' : 'Campo obrigatório'}
                                        floatingLabelText="Máx. avaliadores"
                                        onChange={e => this.setState({ maxAvaliadores: e.target.value })}
                                    />
                                </GridTile>
                            </GridList>

                            <ChipInput
                                value={avaliadoresArea}
                                newChipKeyCodes={[]}
                                fullWidth={true}
                                fullWidthInput={true}
                                floatingLabelText="Avaliadores"
                                onUpdateInput={value => this.buscarAvaliadores(value)}
                                dataSourceConfig={{ text: 'TEXT', value: 'CODIGO' }}
                                dataSource={dsAvaliadoresArea}
                                onRequestDelete={value => this.setState({ avaliadoresArea: avaliadoresArea.filter(x => x.CODIGO !== value) })}
                                onRequestAdd={avaliador => this.setState({ avaliadoresArea: avaliadoresArea.concat(avaliador) })}
                            />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                        <div className="fab-buttons">
                            <FloatingActionButton type="submit" disabled={isPosting} style={{ marginRight: 8 }}>
                                <ContentSave />
                            </FloatingActionButton>
                            <FloatingActionButton onClick={() => this.props.history.goBack()} backgroundColor="rgb(100, 100, 100)">
                                <ContentClear />
                            </FloatingActionButton>
                        </div>
                    </form>
                </div>
            </PrincipalMaster>
        );
    }
}

export default Area;
